module.exports = __webpack_public_path__ + "images/507907d7dd655e160225913e50c6df0b-Colombia.png";